import { useEffect, useState } from 'react';

import { MAP_LAYERS, MARKER_TYPES_CONFIG } from '../../constants';
import { buildOnTapListener } from '../../helpers/buildOnTapListener';
import { useMRE } from '../../hooks/useMRE';
import type { LatLng, MarkerType } from '../../types';

interface MarkerProps {
  latLng: LatLng;
  type: MarkerType;
  onTap?: () => void;
}

export const Marker = ({ latLng, onTap, type }: MarkerProps) => {
  const { terrainEngine } = useMRE();
  const [id, setId] = useState<bigint>();

  // Add / remove the marker
  useEffect(() => {
    if (!terrainEngine || !latLng || !type) {
      return;
    }

    const id = terrainEngine
      .getUtils()
      .addCustomMarker3(
        latLng[0],
        latLng[1],
        JSON.stringify(MARKER_TYPES_CONFIG[type]),
        MAP_LAYERS.stravaPoints,
        undefined
      );

    setId(id);

    return () => {
      terrainEngine.getUtils().removeCustomMarker(id);
    };
  }, [terrainEngine, latLng, type]);

  // Handle tap behavior
  useEffect(() => {
    if (!terrainEngine || id === undefined || !onTap) {
      return;
    }

    // Create an onTap listener that checks if the tapped object matches the marker's id
    const onTapListener = buildOnTapListener({
      onContentTap: (evt) => {
        if (evt.objects.some((object) => object.id === id)) {
          onTap?.();
          return true;
        }

        return false;
      }
    });

    terrainEngine.addOnTapListener(onTapListener);

    return () => {
      terrainEngine.removeOnTapListener(onTapListener);
    };
  }, [terrainEngine, id, onTap]);

  return null;
};
